import React, { useEffect, useState } from 'react';
import NotFound from '../NotFound/NotFoundPage';
import { Box } from '@mui/material';
import { COVERAGE } from '../../shared/Strings';
import PricelistAGgrid from '../CustomAGgrid/PricelistAGgrid';
import { convertToTitleCase } from '../../shared/helper';


function formatTableHeadingForAGgrid(data) {
  return data.map(item => {
    return {
      field: item,
      headerName: convertToTitleCase(item),
      tooltipField: convertToTitleCase(item),
      headerTooltip: convertToTitleCase(item),
    };
  });
}

function CoveragePLTableAndSeach(props) {
  const [filteredData, setFilteredData] = useState(props.data);
  useEffect(() => {
    const searchData = props.data
    setFilteredData(searchData);
  }, [
    props.data, 
  ]);
  return (
    <Box sx={{ ...props.sx }}>
      <Box sx={{display: 'flex', flexDirection: 'row'}}>
        </Box>
      {!filteredData.length ? (
        <NotFound title={COVERAGE.PRICE_LIST} />
      ) : (
        <PricelistAGgrid
          rowData={filteredData}
          columnDefs={formatTableHeadingForAGgrid(props.tableHeading)}
          onItemView={props.onItemView}
        />
      )}
    </Box>
  );
}

export default CoveragePLTableAndSeach;
